import { Sectors } from '../ma-tickers/sub/recovery-ticker-modal/recovery-ticker-modal.component';
import { Currency } from '../../../../company-performance/companies-stocks/enum/Currency';

/**
 * This object is used for the Market Analysis ticker's table and modal
 */
export class StockDataMA {
  public constructor(
    public tickerName?: string,
    public companyName?: string,
    public enterpriseValue?: number,
    public revenueIndex?: number,
    public revenueGrowth?: number,
    public annualRevenue?: number,
    public period?: Date,
    public currencyTicker?: Currency,
    public ebitdaRatio?: number,
    public sectors?: Sectors[],
  ) {}
}
export const StockDataMASorting = {
  byCompanyName: (stockDataMA: StockDataMA): string => stockDataMA.companyName,
  byTickerName: (stockDataMA: StockDataMA): string => stockDataMA.tickerName,
  byEnterpriseValue: (stockDataMA: StockDataMA): number => stockDataMA.enterpriseValue,
  byRevenueIndex: (stockDataMA: StockDataMA): number => stockDataMA.revenueIndex,
  byRevenueGrowth: (stockDataMA: StockDataMA): number => stockDataMA.revenueGrowth,
  byAnnualRevenue: (stockDataMA: StockDataMA): number => stockDataMA.annualRevenue,
  byEbitdaRatio: (stockDataMA: StockDataMA): number => stockDataMA.ebitdaRatio,
};
